<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Edit {{ data.countryLabel }} mapping</h2>
  <p class="dialog-subtitle">What {{ data.countryLabel }} calls the general term <code>{{ data.term }}</code>, and whether it's required.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Local name</mat-label>
    <input matInput [(ngModel)]="localName" name="localName" [placeholder]="data.term" />
    <mat-hint>Leave blank to fall back to the canonical term name.</mat-hint>
  </mat-form-field>

  <div class="checkbox-row">
    <mat-checkbox [(ngModel)]="required" name="required">Required</mat-checkbox>
    <p class="checkbox-hint">Required fields are also written to chain.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting()">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
